export function replaceClasses(className: string, modifyWith: Record<string, string> | undefined): string {
  if (modifyWith === undefined) {
    return className;
  } else {
    const allClasses = className.split(" ");
    const allClassesMap: Record<string, boolean | undefined> = {};
    for (const c of allClasses) {
      const s = c.trim();
      if (!s) continue;
      allClassesMap[s] = true;
    }

    for (const key in modifyWith) {
      for (const cls of key.split(" ")) {
        const s = cls.trim();
        if (!s) continue;
        delete allClassesMap[s];
      }
    }
    for (const val of Object.values(modifyWith)) {
      for (const cls of val.split(" ")) {
        const s = cls.trim();
        if (!s) continue;
        allClassesMap[s] = true;
      }
    }
    return Object.keys(allClassesMap).join(" ");
  }
}
